import React from "react"
import { connect } from "react-redux"
import { withStyles } from "@material-ui/core/styles"
import { withTranslation } from "react-i18next"

import {
  Dialog
} from "@material-ui/core"

import "./HKVDialog.css"

const styles = theme => ({
  root: {
    width: "100%",
    maxHeight: "100%"
  },
  extraSmall: {
    maxWidth: 440,
    [theme.breakpoints.down(440 + theme.spacing(4))]: {
      margin: 0
    },
    [theme.breakpoints.up(440 + theme.spacing(4))]: {
      margin: theme.spacing(4)
    }
  },
  small: {
    maxWidth: 680,
    [theme.breakpoints.down(680 + theme.spacing(4))]: {
      margin: 0
    },
    [theme.breakpoints.up(680 + theme.spacing(4))]: {
      margin: theme.spacing(4)
    }
  },
  medium: {
    maxWidth: 960,
    [theme.breakpoints.down(960 + theme.spacing(4))]: {
      maxHeight: "100%",
      margin: 0
    },
    [theme.breakpoints.up(960 + theme.spacing(4))]: {
      maxHeight: `calc(100% - ${theme.spacing(8 * 2)}px)`,
      margin: theme.spacing(4)
    }
  },
  large: {
    [theme.breakpoints.down("md")]: {
      maxWidth: "100%",
      maxHeight: "100%",
      margin: 0
    },
    [theme.breakpoints.up("md")]: {
      maxWidth: `calc(100% - ${theme.spacing(8 * 2)}px)`,
      maxHeight: `calc(100% - ${theme.spacing(8 * 2)}px)`,
      margin: theme.spacing(4)
    }
  },
  full: {
    maxWidth: "100%",
    width: "100%",
    height: "100%",
    borderRadius: 0,
    margin: 0
  }
})

class HKVDialog extends React.Component {
  render() {
    const { classes, config, onClose } = this.props

    if (!config) return null

    return (
      <Dialog
        open={config.open}
        onClose={() => onClose(config)}
        classes={{
          paper: `${classes.root} ${classes[config.size]}`
        }}
      >
        {this.props.children}
      </Dialog>
    )
  }
}

HKVDialog = withTranslation("translation")(HKVDialog)
HKVDialog = withStyles(styles, { withTheme: true })(HKVDialog)
export default connect(state => state)(HKVDialog)
